import { render, staticRenderFns } from "./button.md?vue&type=template&id=0bf29354"
import script from "./button.md?vue&type=script&lang=js"
export * from "./button.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports